import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Cargo.scss';
import CargoInput from './CargoInput';
import CargoSearch from './CargoSearch';
import CargoTable from './CargoTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/CargoInputReducer';
import { resetCargoSearch, setTriggerCargoSearch, setTriggerFocusCharterer } from './reducers/CargoSearchReducer';

let triggerHotkeyAlready = false;

const Cargo: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Cargo";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        dispatch(setTriggerSave((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        dispatch(setTriggerCargoSearch((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetCargoSearch());
                        dispatch(setTriggerFocusCharterer((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 1500);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <CargoSearch></CargoSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <CargoInput></CargoInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <CargoTable>
                        </CargoTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default Cargo;